import React from "react";
import { Box, Typography } from "@mui/material";
import * as Diff from "diff";

/**
 * DiffView Component
 *
 * Displays the difference between two texts using the diff library.
 * - Green background: Added text (in annotated version)
 * - Red background: Removed text (from original version)
 * - No background: Unchanged text
 */
export const DiffView = ({ originalText, annotatedText }) => {
  const diff = Diff.diffWords(originalText || "", annotatedText || "");

  return (
    <Box sx={{ fontSize: 11, lineHeight: 1.6, fontFamily: "monospace" }}>
      {diff.map((part, index) => {
        let backgroundColor = "transparent";
        let color = "inherit";
        let textDecoration = "none";

        if (part.added) {
          backgroundColor = "#e6ffec";
          color = "#24693d";
        } else if (part.removed) {
          backgroundColor = "#ffebe9";
          color = "#c93026";
          textDecoration = "line-through";
        }

        return (
          <Typography
            key={index}
            component="span"
            sx={{
              backgroundColor,
              color,
              textDecoration,
              fontSize: "inherit",
              fontFamily: "inherit",
              padding: "2px 0",
            }}
          >
            {part.value}
          </Typography>
        );
      })}
    </Box>
  );
};
